<template>
  <div>
    <v-card color="transparent" class="text-left mb-3" elevation="0">
      <v-btn @click="$router.go(-1)" color="transparent" dark elevation="0">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-card>
    <v-alert color="warning" dark v-if="showReviewWarning">
      No reviews yet
    </v-alert>

    <v-card class="white mb-4" v-for="review in reviewsData" :key="review.id">
      <v-card-text class="d-flex flex-wrap">
        <v-avatar size="70" class="flex-shrink-0">
          <img :src="review.avatar" />
        </v-avatar>
        <div class="flex-grow-1 ml-3 min-width-0">
          <v-card-title class="headline py-0">{{ review.name }}</v-card-title>
          <div class="ml-0 ml-sm-4">
            <div class="d-flex align-center mb-2 flex-wrap">
              <v-rating
                :value="review.ratings"
                color="warning"
                background-color="warning"
                half-increments
                dense
                size="20"
                readonly
              />
              <small class="pl-1">{{ review.date }}</small>
            </div>
            <p class="mb-2">
              {{ review.body }}
            </p>
            <div v-if="review.instructorSignature" class="instructor-signature-block mt-2">
              <div class="caption grey--text text--darken-1 mb-1">Instructor signature</div>
              <div class="signature-image-wrap">
                <img :src="review.instructorSignature" alt="Instructor signature" class="instructor-signature-img" />
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      showReviewWarning: false,
      reviewsData: []
    }
  },
  computed: mapGetters(['user', 'reviews']),
  methods: {
    ...mapActions(['toggleDialog', 'getReviewRatings'])
  },

  async created () {
    console.log(this.user.id)
    await this.getReviewRatings({
      reviewFor: this.user.id
    })
    if (this.reviews) {
      this.reviewsData = this.reviews
        ? this.reviews.map((reviews) => {
          return {
            name: `${reviews
                .get('reviewFrom')
                .get('firstName')} ${reviews
                .get('reviewFrom')
                .get('lastName')}`,
            avatar: reviews.get('reviewFrom').get('profilePicture'),
            ratings: reviews.get('star'),
            date: this.$moment(
              reviews.get('appointmentId').get('end')
            ).format('lll'),
            body: reviews.get('review'),
            instructorSignature: reviews.get('instructorSignature') || null
          }
        })
        : []
    } else {
      this.showReviewWarning = true
    }
  }
}
</script>

<style scoped>
.instructor-signature-block {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 10px;
  background: #fafafa;
  max-width: 280px;
}
.signature-image-wrap {
  border-radius: 4px;
  overflow: hidden;
  border: 1px dashed rgba(0, 0, 0, 0.15);
  background: #fff;
}
.instructor-signature-img {
  display: block;
  max-width: 100%;
  height: auto;
  max-height: 80px;
  object-fit: contain;
}
</style>
